import useTranslation from '../../localization/i18n.context';
import NavigationUtils from '../../utils/navigation.utils';

export const EducationalOnboardingType = {
  SendMoney: 'send-money',
};

export default function GetEducationalOnboarding(type) {
  const { t, getOrganization } = useTranslation();

  if (type == EducationalOnboardingType.SendMoney) {
    return [
      {
        id: 'null',
        title: t('Send money to other {company_name} users for free!', {
          '{company_name}':
            getOrganization(NavigationUtils.getOrganizationCode()) ?? '',
        }),
        body: t('In seconds, transfer money to friends without leaving home!'),
        image: '../../../assets/images/send-money.webp',
      },
      {
        id: 'null',
        title: t('Look up your friend in {company_name}', {
          '{company_name}':
            getOrganization(NavigationUtils.getOrganizationCode()) ?? '',
        }),
        body: t('Search by phone number or using your contact list.'),
        image: '../../../assets/images/friends.webp',
      },
      {
        id: 'null',
        title: t('Enter the info & send!'),
        body: t("Enter the amount, check the transfer data and go. That's it!"),
        image: '../../../assets/images/phone.webp',
      },
    ];
  }
}
